module.exports = __webpack_public_path__ + "static/img/s02@2x.121af4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/s02@2x.png
// module id = 9BJj
// module chunks = 1